import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';
import { SidebarToggleComponent } from '@core/components/sidebar/components/footer/expand-toggle/sidebar-toggle.component';
import { SidebarVersionComponent } from '@core/components/sidebar/components/footer/app-version/sidebar-version.component';

@Component({
  selector: 'app-sidebar-footer',
  imports: [NgClass, SidebarToggleComponent, SidebarVersionComponent],
  template: `
    <div
      class="flex w-full min-w-0 items-center gap-x-2 pt-[5px] pb-[9px]"
      [ngClass]="containerClass">
      @if (!collapsed()) {
        <app-sidebar-version class="flex w-full min-w-0" />
      }
      <app-sidebar-toggle class="flex w-min" />
    </div>
  `,
})
export class SidebarFooterComponent {
  /** INPUTS **/
  /****/
  readonly collapsed = input.required<boolean>();

  get containerClass() {
    if (this.collapsed()) return 'justify-center';
    else return 'justify-between';
  }
}
